import React from 'react';
import { RegForm } from './components/public';

var unencodeField = function(selector) {
  return $.parseJSON($('<textarea />').html($(selector).html()).html())
}

let admin = Boolean($('#admin-data').html());
let eb = Boolean($('#eb-data').html());
let fees = unencodeField('#fee-data');
let addons = unencodeField('#addon-data');
let fields = unencodeField('#field-data');

React.render(
  <RegForm fields={fields} fees={fees} addons={addons} eb={eb} admin={admin} />,
  document.getElementById('form-container')
)


/** WEBPACK FOOTER **
 ** ./src/app_public.js
 **/